<template>
  <v-app class="bg-color">
    <v-main>
      <v-container fluid grid-list-xs pt-5>
        <v-layout row wrap justify-center align-center>
          <v-flex xs11 lg11>
            <h2>รายละเอียดความยินยอม</h2>
          </v-flex>
        </v-layout>

        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-text>
                <v-layout row wrap ml-3 pa-1>
                  <v-flex xs11 lg11 pb-3>
                    <b>ความยินยอมเรื่อง: </b> <br />
                    ทดสอบ
                  </v-flex>
                  <v-flex xs11 lg11>
                    <b>ข้อมูลที่ต้องการขอ :</b> <br />
                    <v-btn color="warning" small outlined>111</v-btn>
                  </v-flex>
                  <v-flex xs11 lg11>
                    <b>{{ $t("dashboard.policy") }} :</b> <br />
                    <a>ทดสอบ</a>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs11 lg11>
            <v-card class="rounded-lg">
              <v-card-title primary-title> รายละเอียดความยินยอม </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap pa-2>
                  <v-flex xs11 lg11>
                    <div v-html="DetailConsent"></div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout row wrap justify-center align-center pt-5>
          <v-flex xs10 lg10 pb-2 class="text-center">
            <p class="red--text">*กรุณาตรวจสอบเอกสารก่อนทำารอนุมัติ</p>
          </v-flex>
          <v-flex xs10 lg2 class="mr-5">
            <v-btn color="error" block outlined>ไม่ยินยอม</v-btn>
          </v-flex>
          <v-flex xs10 lg2>
            <v-btn color="#077893" dark block>ยินยอม</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
      <div v-if="loadingDownloadData">
        <OverlaySearch />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import OverlaySearch from '@/components/layouts/LoadingPage.vue'
import authorization from "@/functions/authorization.js";
import Swal2 from "sweetalert2/dist/sweetalert2.js";
import { mapGetters } from "vuex";
const Toast = Swal2.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});
export default {
  components: { OverlaySearch },
  data: function () {
    return {
      HeaderConsent: "",
      DetailTitle: "",
      DetailConsent: "11111",
      RejectReason: "",
      BusinessNameTh: "",
      UpdatdeBy: "",
      loadingDownloadData: false,
    };
  },
  computed: {
    ...mapGetters(["DataConsent"]),
    ...mapGetters(["Business"]),
    ...mapGetters(["RoleAccount"]),

    _RoleAccount: {
      get() {
        return this.RoleAccount || "-";
      },
    },

    _SelectBusinessId: {
      get() {
        return this.Business.BusinessId || "-";
      },
    },
    _ConsentId: {
      get() {
        return this.DataConsent.ConsentId || "-";
      },
    },
  },
  mounted() {
    // this.fn_getDataConsent();
  },
  methods: {
    async fn_getDataConsent() {
      this.loadingDownloadData = true;
      var payload = {
        BusinessId: this.$cookies.get("BusinessId"),
        AccountId: this.$cookies.get("OneAccountId"),
        ConsentId: this._ConsentId,
        RoleAccount: this.$cookies.get("RoleAccountId"),
      };
      var Headers = {
        AccountId: this.$cookies.get("OneAccountId"),
      };
      var dataEncode = await authorization.encodeDataNew(payload);
      var auth = await authorization.encodeDataNew(Headers);
      var headers = { Authorization: "Bearer " + auth };
      this.axios
        .post(
          process.env.VUE_APP_API_FACTORING_SERVICE +
            "consent/GetDetailConsent",
          { Data: dataEncode },
          { headers }
        )
        .then((response) => {
          this.loadingDownloadData = false;

          if (response.data.Status === "OK") {
            this.HeaderConsent = response.data.Message[0].HeaderConsent;
            this.DetailConsent = response.data.Message[0].DetailsConsent;
            this.RejectReason = response.data.Message[0].RejectReason;
            this.BusinessNameTh = response.data.Message[0].BusinessNameTh;
            this.UpdatdeBy = response.data.Message[0].UpdatdeBy;
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.ErrorMessage,
            });
          }
        })
        .catch((error) => {
          this.loadingDownloadData = false;
          if (error.response) {
            Toast.fire({
              icon: "error",
              title: error.response.data.ErrorMessage,
            });
          } else if (error.request) {
            Toast.fire({
              icon: "error",
              title: error.request,
            });
          } else {
            Toast.fire({
              icon: "error",
              title: error.message || error,
            });
          }
        });
    },
  },
};
</script>

<style>
td {
  border-style: hidden !important;
}
</style>

<style scoped>
.bg-color {
  background-color: #ddf7ff;
}
</style>
